import { fetchOfferBasedRecommendations } from 'actions/RecommendationActions'
import { useEffect } from 'react'

import { useAppDispatch } from 'hooks/reduxHooks'
import moment from 'moment'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { occupancyToStr } from 'api/recommendations'
import { isValidOccupancy } from 'lib/offer/occupancyUtils'

function useLoadOfferBasedLereRecommendations(offerId: string | undefined, readyToLoad: boolean, checkIn?: string, checkOut?: string, duration?: number, rooms?: Array<App.Occupants>) {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!offerId || !readyToLoad || (rooms && !isValidOccupancy(...rooms))) {
      return
    }

    let checkOutParam = checkOut
    if (!!duration && !checkOut && !!checkIn) {
      checkOutParam = moment(checkIn).add(duration, 'days').format(ISO_DATE_FORMAT)
    }

    let occupancy: string | undefined = undefined
    if (rooms) {
      occupancy = occupancyToStr(rooms)
    }
    dispatch(fetchOfferBasedRecommendations(offerId, false, checkIn, checkOutParam, occupancy))
  }, [dispatch, offerId, readyToLoad, checkIn, checkOut, duration, rooms])
}

export default useLoadOfferBasedLereRecommendations
